module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-black-mill-finish-724-panel.4a305d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-black-mill-finish-724-panel.jpg
// module id = 1122
// module chunks = 37